import * as React from "react"
import PropTypes from "prop-types"
import { PrimeButton } from "components-design-system"
import { Space } from "antd"
import "./SegmentedButtons.scss"

const SegmentedButtons = ({
  options,
  value: valueProp,
  defaultValue,
  onChange,
  size = "middle",
  block = false,
  className,
  style = {},
}) => {
  const [value, setValue] = React.useState()

  const initValue = React.useMemo(() => {
    if (defaultValue !== undefined) {
      return defaultValue
    } else if (options && options.length > 0 && options?.[0]) {
      return options[0].value
    }
    return null
  }, [defaultValue, options])

  const renderValue = React.useMemo(() => {
    if (valueProp !== undefined) {
      return valueProp
    } else if (value !== undefined) {
      return value
    } else {
      return initValue
    }
  }, [valueProp, value])

  if (!options) return null

  // TODO: work on version where options are an array of strings
  return (
    <Space.Compact
      className={`segmented-buttons${className ? ` ${className}` : ""}${block ? " block" : ""}`}
      style={style}
    >
      {options.map((option, index) => (
        <PrimeButton
          key={option.value}
          type={option.value === renderValue ? "primary" : "default"}
          size={size}
          onClick={() => {
            if (onChange) onChange(option.value)
            setValue(option.value)
          }}
          icon={option.icon}
          className={`segmented-btn-item${index === 0 ? " segmented-btn-item-first" : ""}${index === options?.length - 1 ? " segmented-btn-item-last" : ""}`}
          style={option.style}
        >
          {option.label}
        </PrimeButton>
      ))}
    </Space.Compact>
  )
}

SegmentedButtons.propTypes = {
  options: PropTypes.arrayOf([
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
    }),
  ]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  size: PropTypes.oneOf(["large", "middle", "small"]),
  className: PropTypes.string,
}

export default SegmentedButtons
